import type { MasterOption } from '@/api/masterData.api';

export function formatUtcOffsetMinutes(minutes?: number | string | null): string {
  if (minutes == null || minutes === '') return '';
  const value = typeof minutes === 'string' ? Number(minutes) : minutes;
  if (!Number.isFinite(value)) return '';
  const sign = value >= 0 ? '+' : '-';
  const abs = Math.abs(value);
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  if (mins === 0) return `UTC${sign}${hours}`;
  return `UTC${sign}${hours}:${String(mins).padStart(2, '0')}`;
}

export function formatCountryOption(option: MasterOption): string {
  return `${option.label} (${option.code})`;
}

export function formatCurrencyOption(option: MasterOption): string {
  const symbol = option.extra ? ` · ${option.extra}` : '';
  return `${option.label} (${option.code})${symbol}`;
}

export function formatTaxModeOption(option: MasterOption): string {
  const country = option.extra ? ` · ${option.extra}` : '';
  return `${option.label} (${option.code})${country}`;
}

export function formatTimezoneOption(option: MasterOption): string {
  const offset = formatUtcOffsetMinutes(option.extra);
  return offset ? `${option.label} (${option.code}) · ${offset}` : `${option.label} (${option.code})`;
}

/** Infer region label from IANA zone prefix (Asia/Kolkata → Asia). */
export function inferTimezoneRegion(zoneId: string): string {
  const slash = zoneId.indexOf('/');
  if (slash <= 0) return '';
  const prefix = zoneId.slice(0, slash);
  if (prefix === 'America') return 'Americas';
  if (prefix === 'Pacific' || prefix === 'Australia' || prefix === 'Antarctica') return 'Oceania';
  return prefix;
}

export function countryLabelFromOptions(options: MasterOption[], code: string): string {
  const match = options.find((c) => c.code === code);
  return match ? formatCountryOption(match) : code;
}
